export default {
  "cgu": {
    "heroTitle": "شروط وأحكام الاستخدام",
    "lastUpdated": "آخر تحديث: 3 أغسطس 2026",
    "sections": [
      {
        "title": "1. الديباجة",
        "paragraphs": [
          "تحكم شروط وأحكام الاستخدام هذه (المشار إليها فيما يلي بـ « الشروط ») الوصول إلى واستخدام موقع is-telecom.co (المشار إليه فيما يلي بـ « الموقع »)، الذي تنشره شركة IS TELECOM، وهي شركة مسجلة في بنين، ويقع مقرها الرئيسي في كوتونو، بنين.",
          "عند الوصول إلى الموقع وتصفح صفحاته، يقبل المستخدم (المشار إليه فيما يلي بـ « المستخدم ») دون تحفظ كامل هذه الشروط. إذا كان المستخدم لا يقبل هذه الشروط، يُطلب منه عدم استخدام الموقع."
        ]
      },
      {
        "title": "2. غرض الموقع",
        "paragraphs": ["يهدف الموقع إلى عرض الأنشطة والخدمات والمنتجات التي تقدمها IS TELECOM في المجالات التالية:"],
        "list": [
          "الشبكات الكهروضوئية الصغيرة والكهربة الريفية",
          "حلول الضخ الشمسي والري",
          "تخزين الطاقة وبطاريات الليثيوم",
          "شحن المركبات الكهربائية",
          "الإنشاءات المعدنية والهندسة المدنية",
          "تقنية المعلومات والشبكات وأنظمة المراقبة",
          "التدقيق والاستشارات الطاقوية",
          "الاتصالات والبنى التحتية",
          "النقل والخدمات اللوجستية"
        ],
        "paragraphsAfter": [
          "يسمح الموقع أيضًا للمستخدمين بطلب عرض سعر، والاتصال بـ IS TELECOM، والاطلاع على معلومات حول المشاريع التي أنجزتها الشركة."
        ]
      },
      {
        "title": "3. الوصول إلى الموقع",
        "paragraphs": [
          "الوصول إلى الموقع مجاني ومفتوح لأي مستخدم لديه اتصال بالإنترنت. تتخذ IS TELECOM التدابير اللازمة لضمان توفر الموقع على مدار 24 ساعة طوال أيام الأسبوع، باستثناء حالات القوة القاهرة أو الصيانة التقنية أو التحديثات التي تتطلب انقطاعًا مؤقتًا.",
          "تحتفظ IS TELECOM بالحق في تعديل أو تعليق أو قطع الوصول إلى الموقع، كليًا أو جزئيًا، دون سابق إنذار ودون أن يؤدي ذلك إلى أي تعويض."
        ]
      },
      {
        "title": "4. الملكية الفكرية",
        "paragraphs": [
          "جميع العناصر المكونة للموقع (نصوص، رسومات، شعارات، أيقونات، صور، فيديوهات، أصوات، برامج، قواعد بيانات، إلخ) هي ملكية حصرية لـ IS TELECOM أو شركائها ومحمية بقوانين الملكية الفكرية.",
          "أي استنساخ أو تمثيل أو تعديل أو نشر أو تكييف أو استغلال، كلي أو جزئي، لعناصر الموقع، بأي وسيلة كانت، دون إذن مسبق ومكتوب من IS TELECOM، ممنوع منعًا باتًا ويشكل انتهاكًا."
        ]
      },
      {
        "title": "5. استخدام الموقع",
        "paragraphs": ["يتعهد المستخدم باستخدام الموقع بشكل نزيه ووفقًا للغرض منه. يُمنع على وجه الخصوص:"],
        "list": [
          "استخدام الموقع لأغراض غير قانونية أو احتيالية",
          "إدخال فيروسات أو أحصنة طروادة أو ديدان أو أي برامج ضارة أخرى",
          "تعطيل أو قطع الوصول إلى الموقع أو خوادمه",
          "جمع البيانات الشخصية لمستخدمين آخرين دون موافقتهم",
          "نشر محتويات تشهيرية أو مهينة أو فاحشة أو مخلة بالنظام العام"
        ]
      },
      {
        "title": "6. الروابط التشعبية",
        "paragraphs": [
          "قد يحتوي الموقع على روابط لمواقع طرف ثالث. لا تمارس IS TELECOM أي رقابة على محتوى هذه المواقع وتخلي مسؤوليتها عن محتواها أو دقتها أو تشغيلها. تنشيط هذه الروابط يكون على مسؤولية المستخدم وحده.",
          "أي إنشاء لرابط تشعبي نحو الموقع يجب أن يكون موضوع إذن مسبق ومكتوب من IS TELECOM. تحتفظ IS TELECOM بالحق في طلب إزالة أي رابط غير مصرح به."
        ]
      },
      {
        "title": "7. المسؤولية",
        "paragraphs": [
          "تسعى IS TELECOM إلى ضمان دقة وتحديث المعلومات المنشورة على الموقع. ومع ذلك، لا يمكن لـ IS TELECOM ضمان شمولية أو دقة أو خلو المعلومات المقدمة من الأخطاء. المستخدم مدعو للتحقق من دقة المعلومات لدى IS TELECOM قبل اتخاذ أي قرار.",
          "لا يمكن تحميل IS TELECOM مسؤولية الأضرار المباشرة أو غير المباشرة الناتجة عن استخدام الموقع، أو استحالة الوصول إليه، أو الاطلاع على محتويات من مواقع مرتبطة."
        ]
      },
      {
        "title": "8. البيانات الشخصية",
        "paragraphs": [
          "تجمع IS TELECOM وتعالج البيانات الشخصية للمستخدمين وفقًا لسياستها للخصوصية، المتاحة على الموقع. المستخدم مدعو للاطلاع على هذه السياسة لفهم كيفية جمع بياناته واستخدامها وحمايتها."
        ]
      },
      {
        "title": "9. ملفات تعريف الارتباط",
        "paragraphs": [
          "يستخدم الموقع ملفات تعريف الارتباط وتقنيات مماثلة لتحسين تجربة التصفح وتحليل حركة المرور وتخصيص المحتوى. يمكن للمستخدم إدارة تفضيلات ملفات تعريف الارتباط عبر إعدادات متصفحه."
        ]
      },
      {
        "title": "10. تعديل الشروط",
        "paragraphs": [
          "تحتفظ IS TELECOM بالحق في تعديل هذه الشروط في أي وقت، لا سيما للتكيف مع التطورات القانونية أو التنظيمية أو التقنية. تدخل التعديلات حيز التنفيذ فور نشرها على الموقع. المستخدم مدعو للاطلاع بانتظام على الشروط للتعرف على التعديلات المحتملة."
        ]
      },
      {
        "title": "11. القانون المطبق والاختصاص القضائي",
        "paragraphs": [
          "تخضع هذه الشروط للقانون البنيني. في حالة وجود نزاع يتعلق بتفسير أو تنفيذ أو صحة هذه الشروط، يتعهد الطرفان بالبحث عن حل ودي قبل أي إجراء قضائي. في حالة عدم التوصل إلى اتفاق ودي، تكون المحاكم المختصة في كوتونو، بنين، هي المختصة حصريًا."
        ]
      },
      {
        "title": "12. الاتصال",
        "paragraphs": [
          "لأي سؤال يتعلق بهذه الشروط أو تشغيل الموقع، يمكن للمستخدم الاتصال بـ IS TELECOM على العناوين التالية:"
        ]
      }
    ]
  }
};